module.exports = __webpack_public_path__ + "static/mustardhat-3caf29533205ac61db5753224df5efd6.jpeg";